import { FieldSubject, PropertyTypeQuestion } from '@hb/domain';
import { PropertyStoreService } from '@hb/modules/property/property-store.service';
import { AbstractStoreInjectOption } from '@hb/services/store/abstract-store-inject.service';

import { inject, Injectable, OnDestroy } from '@angular/core';

import { PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';

@Injectable({
    providedIn: 'root'
})
export class PropertyTypeStoreService extends AbstractStoreInjectOption<PropertyTypeQuestion> implements OnDestroy {
    protected readonly store = inject(PropertyStoreService);
    protected readonly lastQuestion = PropertyTypeQuestion.SUMMARY;

    private readonly propertyTypeSubject: FieldSubject<PropertyType>;

    constructor() {
        super();
        this.init();
        const initialValues = this.getInitialValues();
        this.propertyTypeSubject = new FieldSubject<PropertyType>(initialValues);

        this.subscriptions();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.activeQuestionSubject.unsubscribe();
        this.propertyTypeSubject.unsubscribe();
    }

    getPropertyType(): PropertyType {
        return this.propertyTypeSubject.value;
    }

    setPropertyType(propertyType: PropertyType): void {
        this.propertyTypeSubject.next(propertyType);
    }

    getInitialValues(): PropertyType {
        return this.store.getPropertyState()?.property_type;
    }

    update(): void {
        this.store.setPropertyType(this.propertyTypeSubject.value);
    }

    private subscriptions(): void {
        this.propertyTypeSubject.asObservable().subscribe(() => {
            this.update();
            this.nextQuestion();
        });
    }
}
